import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const ThankYou = ({ onReset }) => (
  <motion.div
    key="thanks"
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.35, ease: "easeOut" }}
    className="w-full flex flex-col items-center text-center gap-8"
    data-testid="thank-you-screen"
  >
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 15, delay: 0.1 }}
      className="h-16 w-16 rounded-full bg-[var(--brand-accent)] flex items-center justify-center shadow-[0_10px_30px_-10px_rgba(28,25,23,0.35)]"
    >
      <motion.div
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.35 }}
      >
        <Check className="h-8 w-8 text-[#FDFBF7]" strokeWidth={2.5} />
      </motion.div>
    </motion.div>

    <div className="space-y-3">
      <h2 className="font-serif-display text-3xl sm:text-4xl font-medium tracking-tight text-[#1C1917] leading-snug">
        ¡Gracias por tu opinión! ❤️
      </h2>
      <p className="text-base text-[#57534E] leading-relaxed max-w-xs mx-auto">
        La hemos recibido correctamente. Gracias de parte de todo el equipo
        de La Esquina.
      </p>
    </div>

    <button
      type="button"
      data-testid="reset-rating-button"
      onClick={onReset}
      className="font-mono-label text-xs uppercase tracking-[0.25em] text-[#B38D46] border-b border-[#B38D46]/30 pb-1 hover:text-[#C25E38] hover:border-[#C25E38]/40 transition-colors duration-200 cursor-pointer"
    >
      Valorar de nuevo
    </button>
  </motion.div>
);
